import React, { createContext, useContext, useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { hasFeatureAccess, getTripHistoryLimit, filterTripHistory } from "../utils/featureAccess";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [tier, setTier] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = getAuth();
    const db = getFirestore();

    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        const userDoc = await getDoc(doc(db, "users", currentUser.uid));
        if (userDoc.exists()) {
          setUser(currentUser);
          setTier(userDoc.data().tier || "basic");
        } else {
          setTier("basic");
        }
      } else {
        setUser(null);
        setTier(null);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const checkFeatureAccess = (feature) => {
    return tier ? hasFeatureAccess(tier, feature) : false;
  };

  const getHistoryLimit = () => {
    return tier ? getTripHistoryLimit(tier) : 0;
  };

  const restrictTripHistory = (trips) => {
    return tier ? filterTripHistory(trips, tier) : [];
  };

  return (
    <UserContext.Provider
      value={{
        user,
        tier,
        loading,
        checkFeatureAccess,
        getHistoryLimit,
        restrictTripHistory,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);